import { Switch, type SwitchProps } from '@mui/material'

const CupertinoSwitch = ({ sx, ...props }: SwitchProps) => {
  return (
    <Switch
      {...props}
      sx={{
        width: 44,
        height: 24,
        padding: 0,
        '& .MuiSwitch-switchBase': {
          padding: 0,
          margin: '2px',
          transitionDuration: '300ms',
          '&.Mui-checked': {
            transform: 'translateX(20px)',
            color: '#5BC06B',
            '& + .MuiSwitch-track': {
              backgroundColor: '#E5F5E7',
              opacity: 1,
            },
          },
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 20,
          height: 20,
          boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
        },
        '& .MuiSwitch-track': {
          borderRadius: 12,
          backgroundColor: '#E9E9EA',
          opacity: 1,
          transition: 'background-color 300ms',
          border: '1px solid #A3A5A9',
        },
        ...sx,
      }}
    />
  )
}

export default CupertinoSwitch
